<app-landing-header></app-landing-header>
<br />
<div class="container">
  <div class="container-fluid">
    <div class="social-dash-wrap">
      <div class="row">
        <div class="col-xxl-12 col-xl-12 col-sm-12" style="padding-top: 100px">
          <div class="mb-30">
            <div class="tab-content" id="v-pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="v-pills-home"
                role="tabpanel"
                aria-labelledby="v-pills-home-tab"
              >
                <div class="card h-100 shadow-lg pb-md-50 pb-30 mb-md-50 mb-30">
                  <div class="card-header px-30 pt-30 pb-25 border-bottom-0">
                    <h4 class="fw-500" style="font-size: 40px">FAQ</h4>
                  </div>
                  <div class="card-body pt-0">
                    <div class="application-faqs">
                      <div
                        class="panel-group"
                        id="accordion"
                        role="tablist"
                        aria-multiselectable="true"
                      >
                        <!-- panel 1 -->
                        <div class="panel panel-default">
                          <div class="panel-heading" role="tab" id="headingOne">
                            <h4 class="panel-title">
                              <a
                                data-bs-toggle="collapse"
                                data-parent="#accordion"
                                href="#collapseOne"
                                aria-expanded="true"
                                class=""
                                [innerHTML]="'faq.panel_1.title' | translate"
                              >
                                <!-- Is Removia the same as Norton, McAfee, or other
                                antivirus software? -->
                              </a>
                            </h4>
                          </div>
                          <div
                            id="collapseOne"
                            class="panel-collapse in collapse"
                            role="tabpanel"
                            aria-labelledby="headingOne"
                            style=""
                          >
                            <div class="panel-body">
                              <p
                                class="mb-sm-35 mb-20"
                                [innerHTML]="
                                  'faq.panel_1.description' | translate
                                "
                              >
                                <!-- No, Removia is not an antivirus. While antivirus
                                programs like Norton, McAfee, or Webroot protect
                                your device from malware and viruses, Removia
                                protects your personal data on the internet. We
                                scan the web for your exposed private
                                information – such as your name, address, phone
                                number, and more – being sold or shared by data
                                brokers. Then, we request removal of that data
                                on your behalf. In short: antivirus protects
                                your device; Removia protects your identity and
                                privacy online. -->
                              </p>
                            </div>
                          </div>
                        </div>
                        <!-- panel 2 -->
                        <div class="panel panel-default">
                          <div class="panel-heading" role="tab" id="heading2">
                            <h4 class="panel-title">
                              <a
                                data-bs-toggle="collapse"
                                data-parent="#accordion"
                                href="#collapse2"
                                aria-expanded="true"
                                class=""
                                [innerHTML]="'faq.panel_2.title' | translate"
                              >
                                <!-- Does Removia work on all my devices? Do I need
                                to install anything? -->
                              </a>
                            </h4>
                          </div>
                          <div
                            id="collapse2"
                            class="panel-collapse in collapse"
                            role="tabpanel"
                            aria-labelledby="headingOne"
                            style=""
                          >
                            <div class="panel-body">
                              <p
                                class="mb-sm-35 mb-20"
                                [innerHTML]="
                                  'faq.panel_2.description' | translate
                                "
                              >
                                <!-- Removia isn’t targeting particular devices,
                                Removia protects your identity across the
                                Internet. There’s no software to download or set
                                up on your computer, phone, or tablet. The
                                service works entirely online to scan for your
                                personal data and remove it from data broker
                                websites. We will just create a shortcut on your
                                computer for you to track the data removal
                                progress. -->
                              </p>
                            </div>
                          </div>
                        </div>
                        <!-- panel 3 -->
                        <div class="panel panel-default">
                          <div class="panel-heading" role="tab" id="heading3">
                            <h4 class="panel-title">
                              <a
                                data-bs-toggle="collapse"
                                data-parent="#accordion"
                                href="#collapse3"
                                aria-expanded="true"
                                class=""
                                [innerHTML]="'faq.panel_3.title' | translate"
                              >
                                <!-- My computer doesn’t have email. Why would I need
                                this service? -->
                              </a>
                            </h4>
                          </div>
                          <div
                            id="collapse3"
                            class="panel-collapse in collapse"
                            role="tabpanel"
                            aria-labelledby="headingOne"
                            style=""
                          >
                            <div class="panel-body">
                              <p
                                class="mb-sm-35 mb-20"
                                [innerHTML]="
                                  'faq.panel_3.description' | translate
                                "
                              >
                                <!-- Removia isn’t connected to your device or where
                                you access email. It targets your exposed
                                personal data – like name, phone number,
                                address, or email that’s exposed online –
                                outside your devices. If your information is out
                                there, we work to find and remove it, no matter
                                what device you use. -->
                              </p>
                            </div>
                          </div>
                        </div>
                        <!-- panel 4 -->
                        <div class="panel panel-default">
                          <div class="panel-heading" role="tab" id="heading4">
                            <h4 class="panel-title">
                              <a
                                data-bs-toggle="collapse"
                                data-parent="#accordion"
                                href="#collapse4"
                                aria-expanded="true"
                                class=""
                                [innerHTML]="'faq.panel_4.title' | translate"
                              >
                                <!-- What are data brokers, and how do they get my
                                information? -->
                              </a>
                            </h4>
                          </div>
                          <div
                            id="collapse4"
                            class="panel-collapse in collapse"
                            role="tabpanel"
                            aria-labelledby="headingOne"
                            style=""
                          >
                            <div class="panel-body">
                              <p
                                class="mb-sm-35 mb-20"
                                [innerHTML]="
                                  'faq.panel_4.description' | translate
                                "
                              >
                                <!-- Data brokers are companies that collect, buy,
                                and sell your personal information – like your
                                name, address, phone number, email, or even
                                income range. They gather it from public
                                records, online activity, social media, loyalty
                                programs, and third-party apps, often without
                                your direct consent. Then they sell or share
                                that data with advertisers, marketers, or other
                                organizations. For more details about how data
                                brokers operate, feel free to check out our blog
                                articles. -->
                              </p>
                            </div>
                          </div>
                        </div>
                        <!-- panel 5 -->
                        <div class="panel panel-default">
                          <div class="panel-heading" role="tab" id="heading5">
                            <h4 class="panel-title">
                              <a
                                data-bs-toggle="collapse"
                                data-parent="#accordion"
                                href="#collapse5"
                                aria-expanded="true"
                                class=""
                                [innerHTML]="'faq.panel_5.title' | translate"
                              >
                                <!-- How do you know if my personal data is out
                                there? -->
                              </a>
                            </h4>
                          </div>
                          <div
                            id="collapse5"
                            class="panel-collapse in collapse"
                            role="tabpanel"
                            aria-labelledby="headingOne"
                            style=""
                          >
                            <div class="panel-body">
                              <p
                                class="mb-sm-35 mb-20"
                                [innerHTML]="
                                  'faq.panel_5.description' | translate
                                "
                              >
                                <!-- Data brokers gather personal information from a
                                wide range of public and semi-public
                                sources—such as social media profiles, public
                                records (like property ownership or voter
                                registrations), online purchases, sweepstakes
                                entries, and even third-party apps or websites
                                you’ve interacted with. Most people don’t
                                realize how often their data is shared, bought,
                                or sold without their explicit consent.
                                <br />
                                We monitor up to 300 data broker websites to
                                ensure your data is not exposed there. We also
                                continue to monitor these sources over time, as
                                your data can reappear through ongoing
                                collection practices. -->
                              </p>
                            </div>
                          </div>
                        </div>
                        <!-- panel 6 -->
                        <div class="panel panel-default">
                          <div class="panel-heading" role="tab" id="heading6">
                            <h4 class="panel-title">
                              <a
                                data-bs-toggle="collapse"
                                data-parent="#accordion"
                                href="#collapse6"
                                aria-expanded="true"
                                class=""
                                [innerHTML]="'faq.panel_6.title' | translate"
                              >
                                <!-- Can brokers refuse to remove my data? How do I
                                know it was removed? -->
                              </a>
                            </h4>
                          </div>
                          <div
                            id="collapse6"
                            class="panel-collapse in collapse"
                            role="tabpanel"
                            aria-labelledby="headingOne"
                            style=""
                          >
                            <div class="panel-body">
                              <p
                                class="mb-sm-35 mb-20"
                                [innerHTML]="
                                  'faq.panel_6.description' | translate
                                "
                              >
                                <!-- Yes, in rare cases, some brokers may deny
                                removal – for example, if they claim a legal
                                obligation to keep the data. However, most
                                brokers do honor opt-out requests. Removia
                                handles the process for you and tracks the
                                responses. The Removia team handles all the
                                communication with data brokers on your behalf
                                to ensure your data is deleted from their
                                websites. -->
                              </p>
                            </div>
                          </div>
                        </div>
                        <!-- panel 7 -->
                        <div class="panel panel-default">
                          <div class="panel-heading" role="tab" id="heading7">
                            <h4 class="panel-title">
                              <a
                                data-bs-toggle="collapse"
                                data-parent="#accordion"
                                href="#collapse7"
                                aria-expanded="true"
                                class=""
                                [innerHTML]="'faq.panel_7.title' | translate"
                              >
                                <!-- Is this a subscription that renews automatically
                                each year? -->
                              </a>
                            </h4>
                          </div>
                          <div
                            id="collapse7"
                            class="panel-collapse in collapse"
                            role="tabpanel"
                            aria-labelledby="headingOne"
                            style=""
                          >
                            <div class="panel-body">
                              <p
                                class="mb-sm-35 mb-20"
                                [innerHTML]="
                                  'faq.panel_7.description' | translate
                                "
                              >
                                <!-- Yes. Removia subscriptions renew automatically
                                every year at the current full price at the time
                                of renewal. You’ll receive an email notification
                                30 days before the renewal date, so you have
                                time to make any changes or cancel if needed. -->
                              </p>
                            </div>
                          </div>
                        </div>
                        <!-- panel 8 -->
                        <div class="panel panel-default">
                          <div class="panel-heading" role="tab" id="heading8">
                            <h4 class="panel-title">
                              <a
                                data-bs-toggle="collapse"
                                data-parent="#accordion"
                                href="#collapse8"
                                aria-expanded="true"
                                class=""
                                [innerHTML]="'faq.panel_8.title' | translate"
                              >
                                <!-- What does “You & up to 2/3/4 persons secured”
                                mean? -->
                              </a>
                            </h4>
                          </div>
                          <div
                            id="collapse8"
                            class="panel-collapse in collapse"
                            role="tabpanel"
                            aria-labelledby="headingOne"
                            style=""
                          >
                            <div class="panel-body">
                              <p
                                class="mb-sm-35 mb-20"
                                [innerHTML]="
                                  'faq.panel_8.description' | translate
                                "
                              >
                                <!-- It means you can share your Removia subscription
                                with up to 2, 3, or 4 more people, depending on
                                your plan. Each person you invite will have
                                their own privacy dashboard, where they can
                                track their data removal progress – just like
                                you. -->
                              </p>
                            </div>
                          </div>
                        </div>

                        <!-- panel 9 -->
                        <div class="panel panel-default">
                          <div class="panel-heading" role="tab" id="heading9">
                            <h4 class="panel-title">
                              <a
                                data-bs-toggle="collapse"
                                data-parent="#accordion"
                                href="#collapse9"
                                aria-expanded="true"
                                class=""
                                [innerHTML]="'faq.panel_9.title' | translate"
                              >
                                <!-- So how does Removia work? -->
                              </a>
                            </h4>
                          </div>
                          <div
                            id="collapse9"
                            class="panel-collapse in collapse"
                            role="tabpanel"
                            aria-labelledby="headingOne"
                            style=""
                          >
                            <div class="panel-body">
                              <p
                                class="mb-sm-35 mb-20"
                                [innerHTML]="
                                  'faq.panel_9.description' | translate
                                "
                              >
                                <!-- Once you sign up, you fill out a short
                                authorization form that gives us legal
                                permission to act on your behalf. This allows
                                Removia to contact data brokers and request the
                                removal of your personal information. After
                                that, we scan the internet for your exposed
                                data, submit opt-out requests to hundreds of
                                brokers, and track which ones confirm the
                                removal. You can monitor everything in your
                                personal dashboard. The full removal process
                                takes up to 90 days. Once that cycle is
                                complete, we automatically restart the process
                                to catch any new data that may appear – keeping
                                your privacy protected year-round. -->
                              </p>
                            </div>
                          </div>
                        </div>

                        <!-- panel 11 -->
                        <div class="panel panel-default">
                          <div class="panel-heading" role="tab" id="heading11">
                            <h4 class="panel-title">
                              <a
                                data-bs-toggle="collapse"
                                data-parent="#accordion"
                                href="#collapse11"
                                aria-expanded="true"
                                class=""
                                [innerHTML]="'faq.panel_10.title' | translate"
                              >
                                <!-- What is the authorization form, and why do you
                                need it? -->
                              </a>
                            </h4>
                          </div>
                          <div
                            id="collapse11"
                            class="panel-collapse in collapse"
                            role="tabpanel"
                            aria-labelledby="headingOne"
                            style=""
                          >
                            <div class="panel-body">
                              <p
                                class="mb-sm-35 mb-20"
                                [innerHTML]="
                                  'faq.panel_10.description' | translate
                                "
                              >
                                <!-- The authorization form is a standard document
                                that gives Removia permission to request data
                                removals on your behalf. Many data brokers
                                require proof that someone has your consent
                                before they’ll process removal requests. It’s a
                                simple step but essential to make sure your
                                information gets deleted legally and
                                efficiently. -->
                              </p>
                            </div>
                          </div>
                        </div>

                        <!-- panel 12 -->
                        <div class="panel panel-default">
                          <div class="panel-heading" role="tab" id="heading12">
                            <h4 class="panel-title">
                              <a
                                data-bs-toggle="collapse"
                                data-parent="#accordion"
                                href="#collapse12"
                                aria-expanded="true"
                                class=""
                                [innerHTML]="'faq.panel_11.title' | translate"
                              >
                                <!-- Who is Removia owner? Headquarter? -->
                              </a>
                            </h4>
                          </div>
                          <div
                            id="collapse12"
                            class="panel-collapse in collapse"
                            role="tabpanel"
                            aria-labelledby="headingOne"
                            style=""
                          >
                            <div class="panel-body">
                              <p
                                class="mb-sm-35 mb-20"
                                [innerHTML]="
                                  'faq.panel_11.description' | translate
                                "
                              >
                                <!-- Removia is a service conceived and crafted by
                                GotYourBack Support Technologies Ltd.,
                                headquartered at Spyrou Kyprianou 61, SK House,
                                Limassol, Cyprus. -->
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Edit Profile End -->
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-profile"
                role="tabpanel"
                aria-labelledby="v-pills-profile-tab"
              ></div>
              <div
                class="tab-pane fade"
                id="v-pills-messages"
                role="tabpanel"
                aria-labelledby="v-pills-messages-tab"
              ></div>
              <div
                class="tab-pane fade"
                id="v-pills-settings"
                role="tabpanel"
                aria-labelledby="v-pills-settings-tab"
              ></div>
              <div
                class="tab-pane fade"
                id="v-pills-notification"
                role="tabpanel"
                aria-labelledby="v-pills-notification-tab"
              ></div>
              <div
                class="tab-pane fade"
                id="v-pills-support"
                role="tabpanel"
                aria-labelledby="v-pills-support-tab"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-landing-footer></app-landing-footer>
